const isPwcUs = (organizationName?: string) => (
  organizationName?.toLowerCase() === "pwc-us" || organizationName?.toLowerCase() === "pwc us"
);

export default isPwcUs;
